import { FC, ReactNode } from 'react';
import styles from './Card.module.scss';

export interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card: FC<CardProps> = ({ children, className, onClick }) => (
  <div
    className={`${styles.card} ${className || ''}`}
    onClick={onClick}
  >
    {children}
  </div>
);
